import Component from '../core/Component'
import EventBus from '../core/EventBus'
import { disableScroll, enableScroll } from '../services/Scroll'
import support from '../utils/BrowserSupport'

export const STATES = {
    VISIBLE: 'is-visible',
    ACTIVE: 'is-active',
}

export default class FullModal extends Component {
    constructor(element) {
        super(element)
    }

    prepare() {
        this.form = this.element.querySelector('form')
        this.loading = false
        this.transitionEndListener = this.transitionEndHandler.bind(this)

        this.element.addEventListener(support.transitionEnd, this.transitionEndListener)
    }

    destroy() {
        this.element.removeEventListener(support.transitionEnd, this.transitionEndListener)
    }

    close() {
        if (!this.is(STATES.ACTIVE)) {
            return
        }

        this.element.classList.remove(STATES.ACTIVE)
        enableScroll()
        this.emit('close')
        EventBus.emit('fullmodal:close', {
            id: this.element.id,
        })
    }

    open() {
        disableScroll()
        this.element.classList.add(STATES.VISIBLE)
        this.element.offsetWidth
        this.element.classList.add(STATES.ACTIVE)
        this.emit('open')
        EventBus.emit('fullmodal:open', {
            id: this.element.id,
        })
    }

    toggle() {
        if (this.is(STATES.ACTIVE)) {
            this.close()
        } else {
            this.open()
        }
    }

    transitionEndHandler(event) {
        if (event.target === this.element && !this.is(STATES.ACTIVE)) {
            this.element.classList.remove(STATES.VISIBLE)
        }

    }
}
